enum ErrorCodes {
  PlanningObjectOutdated = "PlanningObjectOutdated",
  Unauthorized = "errors.API.AccessDenied",
  DuplicateUserName = "errors.API.DuplicateUserName",
  NumberOfDevicesExceeded = "errors.API.NumberOfDevicesExceeded",
  DeviceNotLinked = "pages.terminal.notConnected",
  NoValidLicenceForModule = "errors.API.NoValidLicenceForModule",
  noResponse = "errors.API.noResponse",
}

export default ErrorCodes
